// extracted by mini-css-extract-plugin
module.exports = {"base":"styles-m__base__1gPd2","label-grid":"styles-m__label-grid__1ENGC"};